export const TYPE_FETCHING = '_PENDING';
export const TYPE_FETCHED = '_FULFILLED';
export const TYPE_ERROR = '_REJECTED';
